import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
	changeTlsCertificateName: (value: string) => void;
}

export const TlsCertificateNameField: React.FC<IProps> = ({ changeTlsCertificateName }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterTlsCertificateName') }], [t]);

	return (
		<FormInput
			testId="TlsCertificateNameField"
			name="tlsCertificateName"
			label="tlsCertificateNameLabel"
			maxLength={50}
			onChange={changeTlsCertificateName}
			validationRules={validationRules}
		/>
	);
};
